import { Component, OnInit, Input, Inject, TemplateRef, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormAuditType, MasterTemplateCategory, ProjectTempType } from '../Enum/common.enum';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';
import { CCCName } from 'src/app/applicationModules/eSignature/services/form.enum';
import { map, startWith } from 'rxjs/operators';
import { DataSharingService } from '../resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Add3ctypeformComponent } from '../add3ctypeform/add3ctypeform.component';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-addselectParticipant',
  templateUrl: './addselectParticipant.component.html',
  styleUrls: ['./addselectParticipant.component.scss']
})

export class AddSelectParticipantComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  rolesAsssign: any[] = [];
  SendButtonDisabled: boolean = false;
  step = 0;
  participantMessageInfo: string = null;
  toogleInformation = true;
  documentCategoryList: any = [];
  selecteddocumentCategory: number = 0;
  projectGroups: any[] = [];
  ContactNames: string = "";
  Selected3cType: number = 0;
  formID: number = 0;
  TaskID: number = 0;
  Name: string = "";
  Email: string = "";
  Phone: string = "";
  projectId: number = 0;
  //contactNames: string = "";
  //coreNames: string = "";
  searchName: string = '';
  ipAddress: any;
  browsername: any;
  device: any;

  constructor(private http: HttpClient, public dialogRef: MatDialogRef<AddSelectParticipantComponent>,
    private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    private statusConst: StatusConstant, private loaderService: LoaderService,
    private settingsService: SettingService, private _dataSharingService: DataSharingService,
    private router: Router, private httpBackend: HttpBackend) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    var skipInterceptor = new HttpClient(httpBackend);
    skipInterceptor.get<{ ip: string }>('https://jsonip.com').subscribe(data => {
      this.ipAddress = data.ip
    });
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit(): void {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));

    var menuModulesLists = menuModulesList.filter(x => x.mainModuleName == CCCName.Contact);
    if (menuModulesLists.length > 0) {
      this.contactNames = menuModulesLists[0].orgModuleName;
    }

    var menuModulesLists = menuModulesList.filter(x => x.mainModuleName == CCCName.Core);
    if (menuModulesLists.length > 0) {
      this.coreNames = menuModulesLists[0].orgModuleName;
    }
    this.getProjectDetails();
  }


  getProjectDetails() {
    this.projectGroups = [];
    var ReqModel = {
      formID: this.data.formID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      TaskID: this.data.TaskID,
      Name: this.Name,
      Email: this.Email,
      Phone: this.Phone,
      Selected3cType: this.data.Selected3cType,
      projectID: this.data.projectID,
      // UserEmailForCode: (this.portalEmail==null || this.portalEmail)==undefined ?"":this.portalEmail
    }
    this.loaderService.show();
    this.settingsService.CreateProjectFromFormLink(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        let partcipantCheckList = [];
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.projectGroups = this.responseHolder.data;
          if (this.projectGroups.filter(e => e.groupName !== "Send Final Copy" && e.groupName !== "View Only").length > 0) {
            this.participantMessageInfo = this.projectGroups[0].participantMessageInfo;
            for (var i = 0, lennew = this.projectGroups.filter(e => e.groupName !== "Send Final Copy" && e.groupName !== "View Only").length; i < lennew; ++i) {
              var projGrpRelationParticipantList = [];
              // this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList.filter(m => m.isApprover != true);
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              partcipantCheckList = partcipantCheckList.concat(projGrpRelationParticipantList);
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                }
              }
              else {
              }
            }
          }


          if (this.projectGroups.length > 0) {
            this.projectId = this.projectGroups[0].projectID;
            this.ProjectIdForEdit = this.projectGroups[0].projectID;
          }

          var data = [];
          data = this.projectGroups

          var check = []
          check = this.responseHolder.data.filter(x => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if(projGrpRelationParticipantList[i1].participantEmail==null){
                    projGrpRelationParticipantList[i1].participantEmail='';
                  }
                  if (projGrpRelationParticipantList[i1].coreID>0 || projGrpRelationParticipantList[i1].contactID>0 ||
                    projGrpRelationParticipantList[i1].companyID>0 || projGrpRelationParticipantList[i1].pUserID>0 ||
                    projGrpRelationParticipantList[i1].roleID>0 ||  projGrpRelationParticipantList[i1].participantEmail !='') {
                  // if (projGrpRelationParticipantList[i1].contactEmail == "" && projGrpRelationParticipantList[i1].participantEmail == "" && projGrpRelationParticipantList[i1].roleID == "0") {
                    this.SendButtonDisabled = true;
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }
        } else {
          this.loaderService.hide();
          this.projectGroups = [];
          this.toastr.error(this.responseHolder.message, '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
      }
    });
  }

  getShortName(fullName) {
    return fullName.split(' ').map(n => n[0]).join('');
  }

  openProject() {
    this.dialog.closeAll();
    sessionStorage.setItem('projectID', this.ProjectIdForEdit);
    sessionStorage.setItem('type', (ProjectTempType.Project).toString()); // 1 for Project and 2 for Template
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName("");
    this.router.navigate(['/esignature/second']);
    sessionStorage.setItem('HeaderModuleName', 'Forms');
    this._dataSharingService.sendSelectedModuleName('Forms');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }

  getAllCombinedParticipants(data) {
    return data.reduce((acc, group) => acc.concat(group.projGrpRelationParticipantList), []);
  }

  ProjectSend() {
    if (this.projectGroups.length > 0) {
         var check = [];
         var projGrpRelationParticipantList = [];
         check = this.projectGroups.filter(x => x.groupType === 1);
         if (check.length > 0) {       
           projGrpRelationParticipantList =check[0].projGrpRelationParticipantList;
           var checkList = [];
           checkList = projGrpRelationParticipantList.filter(x => (x.contactEmail != null && x.contactEmail != '') || (x.participantEmail != null && x.participantEmail != '') || x.roleID != 0)
            if (checkList.length == 0) {
              this.toastr.warning('Please add atleast 1 participant in a Group.', '', {
                timeOut: 4000,
              });
              return;
             }        
         }
     }
    var ReqModel = {
      folderId: 1,
      projectId: this.ProjectIdForEdit,
      projectName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: 1,  // 1 Form Send , 2 Sand an Save , 3 Save Template Only 
      fileManagerFolderId: 0,
      OfficeID: this.myOfficeID
    }
    this.loaderService.show()
    this.settingsService.AddProjectInfoAsTemplete(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.loaderService.hide();
          this.AddProjectEventLog();
          this.toastr.success('Form has sent successfully to participants.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close('Added');
        } else {
          this.dialog.closeAll();
          this.loaderService.hide();
        }
      } else {
        this.dialog.closeAll();
        this.loaderService.hide();
      }
    });
  }



  onSelectContact(event, relationName, p, p1) {
    if (event.value == p.participantName) {
      this.toastr.warning('Contact already added.', '', {
        timeOut: 3000,
      });
      return;
    }
    var getdata = this.MatchingRole.filter((s) => s.name == event.value && s.roleName == relationName);
    if (getdata.length > 0) {
      this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
      this.groupID = p.groupID;
      this.relationColour = "";
      this.projectID = p1.projectID;
      this.contactemail = p.contactEmail;
      this.relationID = p.relationID;
      this.peoples = [];

      this.peoples.push({
        name: getdata[0].name,
        email: getdata[0].email,
        img: "",
        coreID:0,
        companyID:0,
        contactID: getdata[0].contactID,
        roleID: 0,
        isShared: this.isShare,
        shortName: "",
        typeOfParticipant:2,
      });
      if (this.peoples.length > 0) {
        this.addUpdateParticipantsNew(this.peoples);
        //this.addUpdateParticipants();
      }
    }
  }

  @ViewChild('addAssigne', { static: true }) addAssignedialog!: TemplateRef<any>;
  typeOfParticipant:number=0;
  
  assignUser(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, contact: any, p, p1) {
    this.contactemail = "";
    this.showContact = true;
    this.showSearchCore = false;
    this.selectCoreList = [];

    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.sharedAccessUserList = [];

    this.stateCtrl.setValue('');

    // this.type = p1.type;
    this.projectID = p1.projectID;
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;

    if (isRole)
      this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;
    //this.dialogRef = this.dialog.open(this.addAssignedialog);

    this.dialogRef = this.dialog.open(this.addAssignedialog, {
      panelClass: 'custom-modalbox'
    });
  }

  assignUserNew(isShare: boolean, isRole: boolean, contact: any, p, p1) {
    this.contactemail = "";
    this.showContact = true;
    this.showSearchCore = false;
    this.selectCoreList = [];

    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.sharedAccessUserList = [];

    this.stateCtrl.setValue('');
    this.typeOfParticipant=p.typeOfParticipant;
    // this.type = p1.type;
    this.projectID = p1.projectID;
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;

    if (isRole)
    this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;
   
  const dialogRef = this.dialog.open(Add3ctypeformComponent, {     
        data: {
            moduleName:"",
            typeOfParticipant:this.typeOfParticipant         
         },
         panelClass: 'signatureModal',
       });
       dialogRef.afterClosed().subscribe(result => {
         if(result!=null && result!=undefined){
          this.addUpdateParticipantsNew(result);
         }      
      });
  }

  // Remove Relation 
  RemoveRelation(group, p) {
    const message = `Are you sure you want to delete this participant?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (group !== undefined) {
            var relationListModels = [];
            var ReqModel = {
              groupRelationParticipantMappingID: group.groupRelationParticipantMappingID,
              groupID: group.groupID,
              relationColour: group.relationColour,
              contactID: null,
              relationID: group.relationID,
              projectID: p.projectID,
              roleID: null,
              typeOfParticipant:group.typeOfParticipant
            }
            relationListModels.push(ReqModel)

            var ReqModels = {
              relationListModels: relationListModels,
              userID: this.currentUser.UID,
              databaseID: Number(this.databaseId),
              organizationID: Number(this.organizationId),
              type: 1,//Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
              OfficeID: this.myOfficeID
            }
            this.settingsService.AddEditProjectGroupRelationParticipant(ReqModels).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConst.statusSuccess) {
                  this.loaderService.hide();
                  this.GetGroupList();
                  this.toastr.success('Participant removed successfully', '', {
                    timeOut: 3000,
                  });
                } else {
                  this.loaderService.hide();
                }
              } else {
                this.loaderService.hide();
              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  // dialogRef: MatDialogRef<any, any>;
  //projectGroups: any = [];
  groupID: number;
  projectID: number;
  groupType: any;
  groupRelationParticipantMappingID: number;
  relationColour: string = '';
  relationID: number;
  isShare: boolean = false;
  contactemail: any;
  currentRoleContact: any;
  transRoleList: any = [];
  getassign: any;
  type: number = 1;
  ProjectIdForEdit: "";
  searchValues: string = "";


  contactNames: string = "Email";
  coreNames: string = "";
  menuModulesList: any = [] = [];
  objectList: any = [];
  attachedToCoreList: any = [] = [];
  CorefolderID: number = 0;
  roleIdList: any = [];
  selectCoreList: any = [];
  showSearchCore: boolean = false;
  showContact: boolean = true
  showRole: boolean = false;
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue: string;
  states = this.objectList;

  isSharedAccessRolePopup: boolean = false;
  isRolePopup: boolean = false;
  contactsList: any = [];
  peoples: any = [];
  selectedsharedAccessRole: any = [];
  showAddButton = false;
  Module: string;
  showAddContact: boolean = false;
  sharedAccessRoleList: any = [];
  SharedRoleList: any = [];
  Roles: any = [];
  showContactRoleAddButton = false;
  documentId: number;
  coreID: any;
  isReviewerPopup: boolean = true;
  // SendButtonDisabled: boolean = false;
  timeout = null;
  eventLogMessage: any;
  MatchingRole: any = [];
  selectedUser: boolean = false;
  userSelectedList: any = [];
  isSharedAccessUserPopup: boolean = false;
  sharedAccessUserList: any = [];

  closeAll() {
    if (this.data.moduleName == "Task") {
      this._dataSharingService.sendRefreshListAfterAddingParticipant(true);  
      this.dialog.closeAll();
    //  this.dialogRef.close('Added');
    } else {
      this.dialog.closeAll();
    }
  }

  closeAssign() {
    if (this.dialogRef != undefined) {
      this.dialogRef.close();
    }
  }

  selectSharedAccessRb(value) {
    this.contactemail = "";
    //== For Show Contact==//
    if (value == 1) {
      this.showContact = true;
      this.showRole = false;
      this.showSearchCore = false;
      this.isSharedAccessRolePopup = false;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.selectCoreList = [];
      this.showAddButton = false;
      this.selectedUser = false;
      this.isSharedAccessUserPopup = false;
      this.userSelectedList = [];
      this.sharedAccessUserList = [];
    }
    //== For Show Role==//
    if (value == 2) {
      this.showContact = false;
      this.showRole = true;
      this.showSearchCore = false;
      this.isSharedAccessRolePopup = true;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.selectCoreList = [];
      this.userSelectedList = [];
      this.showAddButton = false;
      this.selectedUser = false;
      this.isSharedAccessUserPopup = false;
      this.sharedAccessUserList = [];
    }
    //== For Show Core==// 
    if (value == 3) {
      this.showContact = false;
      this.showRole = false;
      this.showSearchCore = true;
      this.isSharedAccessRolePopup = false;
      this.selectCoreList = [];
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.userSelectedList = [];
      this.showAddButton = false;
      this.selectedUser = false;
      this.isSharedAccessUserPopup = false;
      this.sharedAccessUserList = [];
    }
    // User
    if (value == 4) {
      this.showContact = false;
      this.showRole = false;
      this.isSharedAccessRolePopup = false;
      this.showSearchCore = false;
      this.isSharedAccessUserPopup = true;
      this.selectCoreList = [];
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.userSelectedList = [];
      this.showAddButton = false;
      this.sharedAccessUserList = [];
    }

  }

  contactSelected(contactSelected: any) {
    if (contactSelected.contactID == 0) {
      this.dialog.closeAll();
      this.addNew('Contact');
      return;
    }
    if (this.peoples.length > 0) {
      return;
    }

    this.peoples.push({
      name: contactSelected.name,
      email: contactSelected.email,
      img: contactSelected.imageUrl,
      contactID: contactSelected.contactID,
      roleID: 0,
      isShared: this.isShare,
      shortName: contactSelected.shortName,
    });
    if (this.peoples.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }

  addNew(module) {
    this.Module = module;
    this.showAddContact = !this.showAddContact;
  }


  getContactListCoreImplementation(searchValue: any) {
    this.searchValues = searchValue;
    this.searchName = searchValue;
    if (searchValue == "") {
      this.contactemail = "";
      this.peoples = [];
      this.contactsList = [];
      return;
    }

    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      searchValue: searchValue,
      PageSize: 0,
      groupID: this.groupID
    }
    this.settingsService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });
        }

        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var check = re.test(String(searchValue).toLowerCase());
        if (check == true) {
          this.contactemail = searchValue;
          this.showAddButton = true;
        }
        if (check == false) {
          this.contactemail = "";
          this.showAddButton = false;
        }
      }
      if (searchValue == "") {
        this.contactemail = "";
        this.peoples = [];
        this.contactsList = [];
      }
    })
  }

  onEnter(event) {
    if (event.target.value == event.target.value.match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      this.contactemail = event.target.value;
      this.peoples.push({
        groupID: this.groupID,
        relationColour: this.relationColour,
        contactID: 0,
        relationID: this.relationID,
        projectID: this.ProjectIdForEdit,
        roleID: null,
        contactEmail: this.contactemail,
      });
      this.addUpdateParticipants();
    }

  }

  RoleSelectedForSharedAccess(roleSelected: any) {
    let role = this.selectedsharedAccessRole.find(m => m.roleID == roleSelected.roleID);
    if (roleSelected.roleID == 0) {
      let newRole = this.selectedsharedAccessRole.find(m => m.name.toLowerCase() == roleSelected.name.toLowerCase());
      if (newRole == undefined) {
        this.selectedsharedAccessRole.push({
          name: roleSelected.roleName,
          email: '',
          img: '',
          userID: "",
          roleID: roleSelected.roleID,
          isShared: false,
          shortName: '',
          CoreID: 0
        });
        if (this.selectedsharedAccessRole.length > 0) {
          this.showAddButton = true;
        }
        if (this.selectedsharedAccessRole.length == 0) {
          this.showAddButton = false;
        }
      }
      return;
    }

    if (role == undefined || role == '' || role == null) {
      this.selectedsharedAccessRole.push({
        name: roleSelected.roleName,
        email: '',
        img: '',
        userID: "",
        roleID: roleSelected.roleID,
        isShared: false,
        shortName: '',
        CoreID: 0
      });
    }
    if (this.selectedsharedAccessRole.length > 0) {
      this.showAddButton = true;
    }
    if (this.selectedsharedAccessRole.length == 0) {
      this.showAddButton = false;
    }
  }

  getSharedAccessRoles(searchValue: any) {
    var ReqModel = {
      searchKey: "",
      pageIndex: 0,
      pageSize: 0,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      searchValue: searchValue
    }
    this.settingsService.getSharedAccessRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sharedAccessRoleList = response.data;
          this.SharedRoleList;
          if (this.SharedRoleList.length > 0) {
            this.sharedAccessRoleList = this.sharedAccessRoleList.filter(({ roleID: id1 }) => !this.SharedRoleList.some(({ roleID: id2 }) => id2 === id1));
          }
        }
        else {
        }
      }
    });
  }

  searchCore(val) {
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;
          this.attachedToCoreList.push(
            {
              "coreID": 0,
              "name": "Create New",
              "email": "",
              "imageUrl": "",
              "isShared": false,
              "coreContactUserMapID": 0,
              "trasactionalRoleIds": [],
              "shortName": ""
            }
          )
        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }

  coreSelected(coreSelected: any) {
    if (coreSelected.coreID == 0) {
      this.dialog.closeAll();
      this.addNew('Core');
      return;
    }
    if (this.selectCoreList.length > 0) {
      return;
    }
    if (coreSelected.email == "" || coreSelected.email == null || coreSelected.email == undefined) {
      this.toastr.warning('Selected ' + this.contactNames + ' is not added email id.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.stateCtrl.setValue('');
    this.selectCoreList.push({
      name: coreSelected.name,
      email: coreSelected.email,
      img: coreSelected.imageUrl,
      coreID: coreSelected.coreID,
      roleID: 0,
      isShared: this.isShare,
      shortName: coreSelected.shortName,
    });
    if (this.selectCoreList.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }

  removeCore(item: any) {
    const index = this.selectCoreList.indexOf(item);
    if (index >= 0) {
      this.selectCoreList.splice(index, 1);
    }
    if (this.selectCoreList.length == 0) {
      this.showAddButton = false;
    }
    this.showSearchCore = true;
  }

  removeItem(item: any, isRolePopup: boolean) {
    if (this.isRolePopup) {
      const index = this.Roles.indexOf(item);
      if (index >= 0) {
        this.Roles.splice(index, 1);
      }
    }
    else {
      const index = this.peoples.indexOf(item);
      if (index >= 0) {
        this.peoples.splice(index, 1);
      }
    }
    if (this.peoples.length == 0) {
      this.showAddButton = false;
    }
    if (this.Roles.length > 0) {
      this.showContactRoleAddButton = true;
    }
    if (this.Roles.length == 0) {
      this.showContactRoleAddButton = false;
    }
  }

  removeItemRoleParticipant(item: any, isSharedAccessRolePopup: boolean) {
    if (this.isSharedAccessRolePopup) {
      const index = this.selectedsharedAccessRole.indexOf(item);
      if (index >= 0) {
        this.selectedsharedAccessRole.splice(index, 1);
      }
      if (this.selectedsharedAccessRole.length > 0) {
        this.showAddButton = true;
      }
      if (this.selectedsharedAccessRole.length == 0) {
        this.showAddButton = false;
      }
    }
  }

  addUpdateParticipants() {
    this.closeAssign();
    if (this.showContact == true) {
      if (this.contactemail != "") {
        var shortname = this.contactemail.substring(0, 1)
        var req1 = {
          name: "",
          email: this.contactemail,
          img: "",
          contactID: 0,
          roleID: 0,
          isShared: this.isShare,
          shortName: shortname,
        }
        this.peoples.unshift(req1);
      }
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var ReqModel = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            contactID: this.peoples[i].contactID,
            relationID: this.relationID,
            projectID: this.projectID,
            roleID: null,
            contactEmail: this.contactemail
          }
          relationListModels.push(ReqModel)
        }

        var ReqModels = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModels).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.GetGroupList();
              this.toastr.success('Participant added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }
    if (this.showRole == true) {
      if (this.selectedsharedAccessRole.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.selectedsharedAccessRole.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            contactID: null,
            relationID: this.relationID,
            projectID: this.projectID,
            roleID: this.selectedsharedAccessRole[i].roleID,
            contactEmail: null
          }
          relationListModels.push(req)
        }
        let ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.GetGroupList();
              this.toastr.success('Participant added successfully.', '', {
                timeOut: 3000,
              });
              this.selectedsharedAccessRole = [];
              this.showAddButton = false;
              this.loaderService.hide();
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }
    if (this.showSearchCore == true) {
      if (this.selectCoreList.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.selectCoreList.length; i < len; ++i) {
          var ReqModelCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            coreID: this.selectCoreList[i].coreID,
            relationID: this.relationID,
            projectID: this.projectID,
            roleID: null,
            contactEmail: this.contactemail
          }
          relationListModels.push(ReqModelCore)
        }

        var ReqModels = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1, //Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModels).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.GetGroupList();
              this.toastr.success('Participant added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }
    if (this.isSharedAccessUserPopup == true) {

      if (this.userSelectedList.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.userSelectedList.length; i < len; ++i) {
          var req11 = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            relationColour: this.relationColour,
            contactID: 0,
            relationID: this.relationID,
            projectID: this.projectID,
            roleID: null,
            contactEmail: this.userSelectedList[i].email,
          }
          relationListModels.push(req11)
        }

        var ReqModels = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1,// 1 for Project and 2 for Template
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModels).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.GetGroupList();
              this.toastr.success('Participant added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }
  }

  addUpdateParticipantsNew(result){
    //this.closeAssign();
    this.peoples =[];
    this.peoples = result;

    //=== For Email ======//
    if (result[0].typeOfParticipant==0) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID:0,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0, 
            userID:0,            
            typeOfParticipant:0//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(req)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.GetGroupList();
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
    }

    //=== For User ======//
    if (result[0].typeOfParticipant==4) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqUser = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID:0,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0, 
            userID:this.peoples[i].userID,             
            typeOfParticipant:4//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqUser)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.GetGroupList();
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
    }

     //=== For Role ======//
     if (result[0].typeOfParticipant==5) {
      if (this.peoples.length > 0) {
      var relationListModels = [];
      for (var i = 0, len = this.peoples.length; i < len; ++i) {
        var reqRole = {
          groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
          groupID: this.groupID,
          coreID:0,
          contactID: 0,
          companyID:0,
          contactEmail: null,
          selectedContactFieldEmailID:0,
          relationID: this.relationID,
          relationColour: this.relationColour,           
          projectID: this.projectID,
          emailFieldID:0,
          nameFieldID:0,
          roleID: this.peoples[i].roleID,
          userID:0,              
          typeOfParticipant:5//this.peoples[i].typeOfParticipant,
        }
        relationListModels.push(reqRole)
      }

      var ReqModel = {
        relationListModels: relationListModels,
        userID: this.currentUser.UID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        type: 1,
        OfficeID:this.myOfficeID
      }
      this.loaderService.show();
      this.settingsService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.GetGroupList();
            this.toastr.success('Participant Added successfully.', '', {
              timeOut: 3000,
            });
            this.peoples = [];
            this.showAddButton = false;
            this.loaderService.hide();             
          }
        }
      });      
    }     
     }

      //=== For Core ======//
     if (result[0].typeOfParticipant==1) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: this.peoples[i].coreID,
            contactID: 0,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,  
            userID:0,           
            typeOfParticipant:1//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCore)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.GetGroupList();
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }

      //=== For Contact ======//
     if (result[0].typeOfParticipant==2) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqContact = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: this.peoples[i].contactID,
            companyID:0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,      
            userID:0,       
            typeOfParticipant:2//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqContact)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.GetGroupList();
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }

      //=== For Company ======//
      if (result[0].typeOfParticipant==3) {
        if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCompany= {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID:this.peoples[i].companyID,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID:0,
            relationID: this.relationID,
            relationColour: this.relationColour,           
            projectID: this.projectID,
            emailFieldID:0,
            nameFieldID:0,
            roleID: 0,     
            userID:0,        
            typeOfParticipant:3//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCompany)
        }
  
        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: 1,
          OfficeID:this.myOfficeID
        }
        this.loaderService.show();
        this.settingsService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {                       
              this.GetGroupList();
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();             
            }
          }
        });      
      }     
     }
   }

  GetGroupList() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      projectID: this.ProjectIdForEdit,
      type: 1,// 1 for Project and 2 for Template
      OfficeID: this.myOfficeID
    }
    this.loaderService.show();
    this.settingsService.GetGroupList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.projectGroups = this.responseHolder.data.groupList;//this.responseHolder.data;
          if (this.projectGroups.length > 0) {
            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var matchRole = [];
                  matchRole = this.MatchingRole.filter(m => m.roleName == projGrpRelationParticipantList[i1].relationName);
                  if (matchRole.length > 0) {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = matchRole;
                  } else {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = null;
                  }
                }
              }
              else {
              }
            }
          }

          if (this.projectGroups.length > 0) {
            this.ProjectIdForEdit = this.projectGroups[0].projectID;
          }

          var data = [];
          data = this.projectGroups;
          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.projectGroups.filter(m => m.groupType == 1);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.projectGroups.filter(m => m.groupType == 2);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage?.replace(/,\s*$/, "") || "";

          var check = [];
          check = this.responseHolder.data.groupList.filter(x => x.groupType === 1);//this.responseHolder.data.filter(x => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if(projGrpRelationParticipantList[i1].participantEmail==null){
                    projGrpRelationParticipantList[i1].participantEmail='';
                  }
                  if (projGrpRelationParticipantList[i1].coreID>0 || projGrpRelationParticipantList[i1].contactID>0 ||
                    projGrpRelationParticipantList[i1].companyID>0 || projGrpRelationParticipantList[i1].pUserID>0 ||
                    projGrpRelationParticipantList[i1].roleID>0 ||  projGrpRelationParticipantList[i1].participantEmail !='')
                  // if (projGrpRelationParticipantList[i1].contactEmail != "" ||
                  //   projGrpRelationParticipantList[i1].participantEmail != "" ||
                  //   projGrpRelationParticipantList[i1].roleID != "0") 
                    {
                    this.SendButtonDisabled = true;
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }
        } else {
          this.loaderService.hide();
          this.projectGroups = [];
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
      }
    });

  }


  // AddRemoveParticipant() {
  //   var ReqModel = {
  //     transactionID: 0,//sessionStorage.getItem('transactionID'),
  //     documentFolderID: 0,
  //     formID: this.data.formID,
  //     formType: FormAuditType.NormalForm,
  //     placeholderID: 0,
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //     OfficeID: this.myOfficeID,
  //     taskID: this.data.TaskID
  //   }
  //   this.loaderService.show();
  //   this.settingsService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       this.loaderService.hide();
  //       if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //         this.projectGroups = this.responseHolder.data.participants;//this.responseHolder.data;
  //         if (this.projectGroups.length > 0) {
  //           for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
  //             var projGrpRelationParticipantList = [];
  //             projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
  //             if (projGrpRelationParticipantList.length > 0) {
  //               for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
  //                 var matchRole = [];
  //                 matchRole = this.MatchingRole.filter(m => m.roleName == projGrpRelationParticipantList[i1].relationName);
  //                 if (matchRole.length > 0) {
  //                   this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = matchRole;
  //                 } else {
  //                   this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = null;
  //                 }
  //               }
  //             }
  //             else {
  //             }
  //           }
  //         }

  //         if (this.projectGroups.length > 0) {
  //           this.ProjectIdForEdit = this.projectGroups[0].projectID;
  //         }

  //         var data = [];
  //         data = this.projectGroups;
  //         if (data.length > 0) {
  //           this.eventLogMessage = "Sent for signature to ";
  //           var checkGroup = this.projectGroups.filter(m => m.groupType == 1);
  //           if (checkGroup.length > 0) {
  //             var projGrpRelationParticipantList = [];
  //             projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
  //             for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
  //               var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
  //               var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
  //               var email = "";
  //               if (checkEmailAnonmous != "") {
  //                 email = checkEmailAnonmous;
  //                 this.eventLogMessage += '(' + email + '), ';
  //               }
  //               if (checkEmail != "") {
  //                 email = checkEmail;
  //                 this.eventLogMessage += '(' + email + '), ';
  //               }
  //             }
  //           }

  //           var checkViewOnly = this.projectGroups.filter(m => m.groupType == 2);
  //           if (checkViewOnly.length > 0) {
  //             for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
  //               var projGrpRelationParticipantList = [];
  //               projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
  //               for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
  //                 var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
  //                 var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
  //                 var email = "";
  //                 if (checkEmailAnonmous != "") {
  //                   email = checkEmailAnonmous;
  //                   this.eventLogMessage += '(' + email + '), ';
  //                 }
  //                 if (checkEmail != "") {
  //                   email = checkEmail;
  //                   this.eventLogMessage += '(' + email + '), ';
  //                 }
  //               }
  //             }
  //           }
  //         }

  //         this.eventLogMessage = this.eventLogMessage.replace(/,\s*$/, "");

  //         var check = [];
  //         check = this.responseHolder.data.participants.filter(x => x.groupType === 1);//this.responseHolder.data.filter(x => x.groupType === 1);
  //         if (check.length > 0) {
  //           for (var i = 0, len = check.length; i < len; ++i) {
  //             var projGrpRelationParticipantList = [];
  //             projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
  //             if (projGrpRelationParticipantList.length > 0) {
  //               for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
  //                 if (projGrpRelationParticipantList[i1].contactEmail != "" ||
  //                   projGrpRelationParticipantList[i1].participantEmail != "" ||
  //                   projGrpRelationParticipantList[i1].roleID != "0") {
  //                   this.SendButtonDisabled = true;
  //                   return;
  //                 } else {
  //                   this.SendButtonDisabled = false;
  //                   // return;
  //                 }
  //               }
  //             }
  //             else {
  //             }
  //           }
  //         }
  //       } else {
  //         this.loaderService.hide();
  //         this.projectGroups = [];
  //       }
  //     } else {
  //       this.loaderService.hide();
  //       this.projectGroups = [];
  //     }
  //   });

  // }

  // To Add Project EventLog //
  async AddProjectEventLog() {
    try {
      var ReqModel = {
        projectID: this.ProjectIdForEdit,
        ipAddress: this.ipAddress,
        message: this.eventLogMessage,
        eventType: 1, //Sent=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        device: this.device,
        browser: this.browsername,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
      }
      const result = await this.settingsService.AddProjectEventLog(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConst.statusSuccess) {
      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }


  searchUser(val) {
    if (val.length >= 2) {
      this.sharedAccessUserList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getUserListCoreImplementation(val)
        }, 500);
      } else {
        this.sharedAccessUserList = [];
      }
    }
  }

  getUserListCoreImplementation(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.sharedAccessUserList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.settingsService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sharedAccessUserList = response.data.userModel;
          this.sharedAccessUserList.map((res) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.sharedAccessUserList = this.sharedAccessUserList;
        }
      }
    });
  }


  userSelected(userSelected: any) {
    var user = [];
    user = this.userSelectedList.filter(m => m.userID == userSelected.userID);
    if (user.length == 0) {
      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');
      this.userSelectedList.push({
        name: userSelected.firstName + " " + userSelected.lastName,
        email: userSelected.email,
        userID: userSelected.userID,
        img: "",
        shortName: shortName,
      });
    } else {
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if (this.userSelectedList.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }

  removeUser(item: any) {
    const index = this.userSelectedList.indexOf(item);
    if (index >= 0) {
      this.userSelectedList.splice(index, 1);
    }
    if (this.userSelectedList.length == 0) {
      this.showAddButton = false;
    }
  }

}


